/**
 * Пути к ассетам фруктовой темы.
 * Файлы лежат в public/assets/fruit/ (Vite отдаёт их с корня как /assets/fruit/...).
 * У фруктов с соком (red, green, blue): symbol — целый, symbol_cut — разрезанный, symbol_juice — сок при разрезе.
 */

const BASE = '/assets/fruit';

export const FRUIT_ASSETS = {
  /** Символы центрального барабана. Расширения как в public/assets/fruit/ */
  symbol_watermelon: `${BASE}/symbol_watermelon.webp`,
  symbol_watermelon_cut: `${BASE}/symbol_watermelon_cut.webp`,
  symbol_watermelon_juice: `${BASE}/symbol_watermelon_juice.webp`,
  symbol_dragon: `${BASE}/symbol_dragon.webp`,
  symbol_dragon_cut: `${BASE}/symbol_dragon_cut.webp`,
  symbol_dragon_juice: `${BASE}/symbol_dragon_juice.webp`,
  symbol_kiwi: `${BASE}/symbol_kiwi.webp`,
  symbol_kiwi_cut: `${BASE}/symbol_kiwi_cut.webp`,
  symbol_kiwi_juice: `${BASE}/symbol_kiwi_juice.webp`,
  symbol_rotten: `${BASE}/symbol_rotten.webp`,
  symbol_unripe: `${BASE}/symbol_unripe.webp`,
  juice_red: `${BASE}/juice_red.webp`,
  juice_yellow: `${BASE}/juice_yellow.webp`,
  juice_green: `${BASE}/juice_green.webp`,
  segment_empty: `${BASE}/segment_empty.webp`,
  /** Картинка момента рассечения (общая для всех фруктов) — сочный кадр разреза, затем сок и разрезанный фрукт */
  cut_slice: `${BASE}/cut.webp`,
  /** Меч для анимации взмаха */
  sword: `${BASE}/sword.webp`,
} as const;

export type DrumSegmentType = 'red' | 'green' | 'blue' | 'gray' | 'skull';

/** Маппинг тип сегмента барабана → URL текстуры фрукта (целый) */
export const DRUM_SYMBOL_ASSET: Record<DrumSegmentType, string> = {
  red: FRUIT_ASSETS.symbol_watermelon,
  green: FRUIT_ASSETS.symbol_dragon,
  blue: FRUIT_ASSETS.symbol_kiwi,
  gray: FRUIT_ASSETS.symbol_unripe,
  skull: FRUIT_ASSETS.symbol_rotten,
};

/** Фрукты с соком: целый, разрезанный, сок. Для gray/skull только symbol. */
export const DRUM_SYMBOL_CUT_JUICE: Partial<Record<DrumSegmentType, { symbol: string; cut: string; juice: string }>> = {
  red: {
    symbol: FRUIT_ASSETS.symbol_watermelon,
    cut: FRUIT_ASSETS.symbol_watermelon_cut,
    juice: FRUIT_ASSETS.symbol_watermelon_juice,
  },
  green: {
    symbol: FRUIT_ASSETS.symbol_dragon,
    cut: FRUIT_ASSETS.symbol_dragon_cut,
    juice: FRUIT_ASSETS.symbol_dragon_juice,
  },
  blue: {
    symbol: FRUIT_ASSETS.symbol_kiwi,
    cut: FRUIT_ASSETS.symbol_kiwi_cut,
    juice: FRUIT_ASSETS.symbol_kiwi_juice,
  },
};
